import { createAction, props } from '@ngrx/store';

export const increment = createAction('[Landing Comp] Increment');
export const decrement = createAction('[Landing Comp] Decrement');
export const reset = createAction('[Landing Comp] Reset');

export const addBook = createAction('[Book List] Add Book', props<{bookId}>());
export const removeBook = createAction('[Book Collection] Remove Book', props<{bookId}>());
export const retrievedBookList = createAction('[Book List/API] Retrieve Books Success', props<{book}>());